<section>
    <div class="login_page_text">
      <div class="__img">
        <img src="assets/img/grt_logo_final.png">
        </div>
        <div class="__text">
          <h1 class="headerBar" >GRT Global Logistics</h1>
          <p class="postHeaderBar">Logistics Management System</p>
          <p class="companyStatus">GRT Global Logistics Pvt. Ltd., established in 1998, is a leading international freight forwarder, LCL aggregator and logistics service provider, with its headquarters in Mumbai, India. GRT offers customized cost-effective technology driven transport and logistics solutions using the fastest and most effective modes of transport for import, export and cross trades. 
            GRT offers direct LCL export and import services to more than 50 worldwide destinations and to more than 3000 worldwide destinations via international LCL hubs.
            GRT also offers international air transport services for your import and export goods, for all industry segments.
        </p>
          
       </div>
      </div>
    </section>